import React from 'react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
const STEPS = [{
  num: '1',
  title: 'Start Your Order',
  desc: 'Contact PTS, send your quote, or tell us what your team needs.'
}, {
  num: '2',
  title: 'Design & Artwork',
  desc: 'Work with the art team on mockups, colors, logos, and uniform details.'
}, {
  num: '3',
  title: 'Samples & Approvals',
  desc: 'Review designs, product samples, size samples, or production photos.'
}, {
  num: '4',
  title: 'Submit Team Details',
  desc: 'Enter sizes, names, numbers, colors, and order details.'
}, {
  num: '5',
  title: 'Production & Delivery',
  desc: 'After approval and deposit, your order moves through production and ships.'
}];
export function OrderProcess() {
  return <section className="py-20 bg-white" data-id="element-180">
      <Container data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4 text-gray-900" data-id="element-183">
            How the Order Process Works
          </h2>
          <div className="w-24 h-1.5 bg-pts-red mx-auto mb-6" data-id="element-184"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-185">
            We've built a simple, organized process to ensure your uniforms are
            designed, approved, and delivered accurately.
          </p>
        </div>

        <div className="relative" data-id="element-186">
          {/* Desktop Timeline Line */}
          <div className="hidden lg:block absolute top-12 left-0 w-full h-1 bg-gray-200 -z-10" data-id="element-187"></div>

          {/* Mobile Timeline Line */}
          <div className="lg:hidden absolute top-0 left-8 w-1 h-full bg-gray-200 -z-10" data-id="element-188"></div>

          <div className="flex flex-col lg:flex-row justify-between gap-8 lg:gap-4" data-id="element-189">
            {STEPS.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="relative flex lg:flex-col items-start lg:items-center text-left lg:text-center group" data-id="element-190">
                <div className="flex-shrink-0 w-16 h-16 bg-white border-4 border-gray-200 group-hover:border-pts-red rounded-full flex items-center justify-center font-oswald text-2xl font-bold text-gray-400 group-hover:text-pts-red transition-colors duration-300 mb-0 lg:mb-6 z-10 mr-6 lg:mr-0" data-id="element-191">
                  {step.num}
                </div>
                <div data-id="element-192">
                  <h3 className="font-oswald text-xl font-bold text-gray-900 uppercase mb-2" data-id="element-193">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed max-w-[220px]" data-id="element-194">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-16 bg-gray-50 border border-gray-200 rounded-lg p-6 text-center max-w-3xl mx-auto" data-id="element-195">
          <p className="text-gray-800 font-medium" data-id="element-196">
            <span className="text-pts-red font-bold uppercase mr-2" data-id="element-197">
              Pro Tip:
            </span>
            Planning early saves stress. Early Bird options and sample deposits
            can help teams lock in pricing and plan ahead.
          </p>
        </div>
      </Container>
    </section>;
}